<template>
  <div class="flex justify-center gap-1 sm:gap-2.5 mt-2 flex-wrap">
    <img
      v-for="item in paymentMethods"
      :key="item.slug"
      :alt="item.alt"
      :src="`/payment-methods/${item.slug}.svg`"
      class="h-7 border rounded-md border-gray-200"
    />
  </div>
</template>
<script setup lang="ts">
import { getFilteredPaymentMethods } from '../../../constants/paymentMethods'

const { isEmbedded } = useEmbeddedCheckout()
const isSubdomain = useIsSubdomain()
const isBookingSolution = computed(() => isEmbedded.value || isSubdomain.value)
const paymentMethods = computed(() =>
  getFilteredPaymentMethods(isBookingSolution.value)
)
</script>

<style lang="css" scoped>
@reference '~/assets/css/tailwind.css';
.cart-payment {
  @apply inline-flex flex-col items-center p-3 pb-4 border border-gray-200 rounded-lg;
  box-shadow: 0 4px 16px 0 rgba(31, 42, 55, 0.06);
}
</style>
